import { render, staticRenderFns } from "./lesscompute.vue?vue&type=template&id=3032456c&scoped=true&"
import script from "./lesscompute.vue?vue&type=script&lang=js&"
export * from "./lesscompute.vue?vue&type=script&lang=js&"
import style0 from "./lesscompute.vue?vue&type=style&index=0&id=3032456c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3032456c",
  null
  
)

export default component.exports